import { useEffect, useState } from "react";
import { requestGetAdvisers } from "services/appointment/relatedToAppointment";
import { requestGetAllCampus } from "services/general";

const useFetchData = ({
    loadingRequest
}) => {
    //#region States
    const [advisers, setAdvisers] = useState([]);
    const [allCampus, setAllCampus] = useState([]);
    const [loaded, setLoaded] = useState(false);
    //#endregion
    //#region Functions
    const loadData = async () => {
        loadingRequest.show();
        await fillAdvisers();
        await fillAllCampus();
        loadingRequest.hide();
        setLoaded(true);
    }
    const fillAdvisers = async () => {
        const data = await requestGetAdvisers();
        setAdvisers(data);
    }
    const fillAllCampus = async () => {
        const fetchAllCampus = await requestGetAllCampus();
        setAllCampus(fetchAllCampus.map(({ id: value, name: text }) => ({ value, text })));        
    }
    //#endregion
    return {
        load: loadData,
        loaded,
        data: {
            advisers,
            allCampus
        }
    };
}

export default useFetchData;